import { useShallow } from 'zustand/react/shallow';
import { useChallengeFormStore } from '../../NewChallengeForm.store';

export const useRegisterDateTime = () =>
  useChallengeFormStore(
    useShallow((s) => ({
      registerStartDate: s.challenge.registerStartDate,
      registerEndDate: s.challenge.registerEndDate,
    })),
  );

export const useRegisterEndDateTimeActions = () => {
  const updateChallengeForm = useChallengeFormStore(
    (s) => s.updateChallengeForm,
  );

  const setRegisterEndDateTime = (registerEndDate: string) =>
    updateChallengeForm({ registerEndDate });

  return { setRegisterEndDateTime };
};
